import { useEffect, useState } from "react";
import api from "../lib/api";

export default function SecureAvatar({ investorId, name, size = 48, testId }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let url;
    setSrc(null);
    if (investorId) {
      api.get(`/investors/${investorId}/photo`, { responseType: "blob" })
        .then((r) => {
          url = window.URL.createObjectURL(r.data);
          setSrc(url);
        })
        .catch(() => setSrc(null));
    }
    return () => { if (url) window.URL.revokeObjectURL(url); };
  }, [investorId]);

  const initials = (name || "U").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();

  if (src) {
    return (
      <img src={src} alt={name} data-testid={testId}
        className="rounded-full object-cover border border-emerald-500/25 shrink-0"
        style={{ width: size, height: size }} />
    );
  }
  return (
    <div data-testid={testId}
      className="rounded-full bg-emerald-500/10 border border-emerald-500/25 text-emerald-300 flex items-center justify-center font-display shrink-0"
      style={{ width: size, height: size, fontSize: size * 0.38 }}>
      {initials}
    </div>
  );
}
